<template>
  <div class="navbar">

    <div class="navbar-logo" >
       <div class="top-logo">
          <span>CCC免办及特殊用途进口产品检测处理管理系统</span>
      </div>
    </div> 

    <!-- <div class="navbar-logo">
      <div class="logoimg"></div>
      <div class="header-img-left"></div>
      <div class="header-img-center"></div> 
      <span class="login-title">CCC免办及特殊用途进口产品检测处理管理系统</span>
    </div> -->
    <div class="header-right"  v-if="name">
     <!-- {{name}} -->
        <p class="header-company-name">{{name}}</p>

        <div class="header-msg">
           <svg-icon class="header-svg" icon-class='msg-icon' @click="showMessage"></svg-icon>
         <p class="header-text" @click="showMessage">您有{{this.$store.state.message.messageCount}}条新消息</p> 
        </div>
        <el-tooltip content="个人中心" placement="bottom" effect="light">
      <svg-icon class="header-svg" icon-class='user-icon' @click="modifyInfor"></svg-icon></el-tooltip>
      <el-tooltip content="技术支持" placement="bottom" effect="light"><svg-icon class="header-svg-call" icon-class='call-center' @click="mainPage"></svg-icon></el-tooltip>
      <el-tooltip content="退出" placement="bottom" effect="light"><svg-icon class="header-svg" icon-class='logout-icon' @click="logOut"></svg-icon></el-tooltip>
    </div>
    <el-dialog title="补充手机号" :visible.sync="mobileDialog" :modal="false" :show-close="false">
                <el-form ref="mobileSubmit" :model="mobileSubmit" :rules="mobileRules" class="queryForm" label-width="100px">
                <el-row :gutter="20">
                    <el-col :span="20">
                        <el-form-item prop="mobile" label="联系电话" label-width="120px">
                            <el-input v-model="mobileSubmit.mobile"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                
                
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="mobileEdit">保 存</el-button>
                </span>
            </el-dialog>

    <!-- <el-dialog
      @closed="closedPassDialog"
      :visible.sync="passwordDialog"
      :modal-append-to-body="false"
       :close-on-click-modal ="false"
       :show-close ="false"
    >
    <div slot="title" class="dialog-title">
         <i class="el-icon-edit-outline"></i>
    <span class="title-text">{{'修改密码'}}</span>
      <div class="dialog-btn">
        <el-button @click="saveNewpsw" type="primary" size="mini"> 确 定</el-button>
        <el-button @click="passwordDialog = false" size="mini">取 消</el-button>
      </div>
          
      </div>
      <div class="dialog-content">
      <el-form
          :model="passForm"
          :rules="rules"
          ref="Form"
         
          label-width="100px"
          class="dialogForm"
          
        >
          <el-form-item label="旧密码" prop="oldPass">
            <el-input
              v-model="passForm.oldPass"
              type="password"
              placeholder="请输入旧密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="pass">
            <el-input
              type="password"
              v-model="passForm.pass"
              autocomplete="off"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="checkPass">
            <el-input
              type="password"
              v-model="passForm.checkPass"
              autocomplete="off"
              placeholder="请输入新密码"
            ></el-input>
          </el-form-item>
         
        </el-form>
  
      </div> 

     
    </el-dialog> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { changePass,getUser,pwdPrompt } from '@/api/login/login'
import { updateUser } from '@/api/system/user'
import {  MessageBox } from 'element-ui'
import {
  selectMessageList,
  editMessageRemind
} from '@/api/system/messageReminder'
import { remove } from 'js-cookie'
export default {
  computed: {
    ...mapGetters(['sidebar']),
     name() {
      return this.$store.state.user.userName
    }
  },
  data() {
    var validatePass = (rule, value, callback) => {
      let reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,12}$/
      if (value === '') {
        callback(new Error('请输入密码'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入8-12位，必须包含字母和数字'))
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.Form.validateField('checkPass')
        }
        callback()
      }
    }
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      passForm: {
        pass: '',
        checkPass: '',
        oldPass: ''
      },
      mobileRules:{
        mobile:[
                    { required: true, message: '请输入手机号', trigger: 'blur' }
                ],
      },
      mobileDialog:false,
      mobileSubmit:{
        mobile:''
      },
      count:'',
      rules: {
        pass: [{ validator: validatePass, trigger: 'blur' }],
        checkPass: [{ validator: validatePass2, trigger: 'blur' }],
        oldPass: [{ required: true, message: '请输入旧密码', trigger: 'blur' }]
      },
      passwordDialog: false
    }
  },
  mounted() {
    this.loadExternalScript();
    if(typeof this.$store.state.user.token != 'undefined' && this.$store.state.user.token != ''){
      this.selectMessageList()
    }
  },
  methods: {

    loadExternalScript() {
      const script = document.createElement('script');
      script.onload = () => {
        console.log('External script loaded successfully');
        this.callback(); // 加载成功后执行回调函数
      };

      script.onerror = () => {
        console.error('Failed to load external script');
      };

      script.charset = 'UTF-8';
      script.src = 'https://xxzxmcs.e-cqs.cn/mcs.js?v=' + new Date().getUTCDate() + '&id=cnp1bm1jaxd4mg&appName=sadmin262&appChannel=20072';
     
      document.head.appendChild(script);
    },
    callback() {
      var _this = this
      var id = _this.$store.state.user.id;
      var name = _this.$store.state.user.userName;
      var mobile = _this.$store.state.user.userInfo.mobile;
      var email = _this.$store.state.user.userInfo.email;
      var office = _this.$store.state.user.userInfo.orgName;
      window.jiaxinCallback.on('renderSuccessful', function(result) {
        var json = {};
        json.cid = id;///"${fns:getUser().id}";
        json.crm = {"name":name,"mobile":mobile,"email":email,"company":office,"remark":"CCC免办及特殊用途进口产品检测处理管理系统"};
        json.session = {"log":"0"};
        window.jiaxinInit(json);
      });
    },

    mobileEdit(){
      this.$refs.mobileSubmit.validate(valid => {
        if(valid){
          delete this.mobileSubmit.password
          updateUser(this.mobileSubmit).then(res => {
            if(res.code == 0){
              this.success('upd')
              this.mobileDialog = false
            }
          })
        }
      })

      
    },
    mainPage(){
      this.$router.push({name: 'Dashboard'})
    },
    showMessage(){
      this.$router.push({name: 'messageReminder'})
    },
    selectMessageList(){
      
      
      //params.receiveUserId = '4028824e70dc10340170e66aa7691466'
      //params.receiveUserId = this.$store.state.user.userInfo.id
      getUser().then(res => {
        if(res.data.mobile == null || res.data.mobile == ""){
          this.mobileSubmit = res.data
          this.mobileDialog = true
        }
        this.getPwdPrompt(res.data.id)
        this.getMessageFun(res.data.id)
      })
    },
    getPwdPrompt(id){
      pwdPrompt({userId:id}).then(res => {
        if(res.code == 0){
          if(res.data == null){
            
          }
          else
          {
            this.$confirm(res.data,'提示',{
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(res => {
              this.$router.push({path:'/system/personalInfor'})
            }).catch(()=>{}) // 添加错误捕获


          }
        }
      })
    },
    getMessageFun(id){
      var _this = this
      var params = {}
      params.receiveUserId = id
      params.messageStatus = 0
        selectMessageList(params).then(res => {
          if(res.code == 0){
            var dataList = res.data
            _this.$store.commit('changeMessageCount',res.data.length)
            var offset = 100
            dataList.forEach(item => {
              const h = _this.$createElement;
              _this.$notify.info({
                title: item.messageSubject,
                dangerouslyUseHTMLString: true,
                offset: offset,
                message: '<div style="width:250px;font-size:10px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis">'+item.messageContent+'</div><div style="text-align:right;font-size:10px">'+item.sendTime+'</div>',
                onClick: function(){
                  //改成已读
                  params.id = item.id
                  var funcParamId = JSON.parse(item.funcParamId)

                  editMessageRemind(params).then(res2 => {
                    if(res2.code == 0){
                      //再出发查询消息数量
                      selectMessageList(params).then(res3 => {
                        if(res3.code == 0){
                          _this.$store.commit('changeMessageCount',res3.data.length)
                          if(item.webAddrName == 'applyEditor'){
                            var str = item.funcParamId.split(',')
                            for(var i = 0 ; i < str.length;i++){
                              var strArr = str[i].split('=')
                              sessionStorage.setItem(strArr[0], strArr[1] )
                            }
                            
                          }
                          _this.$router.push({name: item.webAddrName,query:funcParamId})
                        }
                      })
                    }
                  })
                  
                }
              })
              offset += 90
            });
          }
        })
    },
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    },
    logOut() {
      MessageBox(`确定要退出吗？`,'提示',{
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(res => {
   this.$store.dispatch('user/LogOut')     
      }).catch(()=>{}) // 添加错误捕获
      
    },
    closedPassDialog() {
      this.$refs.Form.resetFields()
      this.passForm = {
        pass: '',
        checkPass: '',
        oldPass: ''
      }
    },
    saveNewpsw() {
      this.$refs.Form.validate(valid => {
        if (valid) {
          changePass(this.passForm).then(res => {
            if (res.code == 0) {
              this.passwordDialog = false
            }
          })
        } else {
          //console.log('error submit!!')
          return false
        }
      })
    },
    modifyInfor(){
      let types = this.$store.state.user.userInfo.userType
      /// console.log("types===="+types)
        if(types === '1' ){
         //// console.log(this.$store.state.user.userInfo)
          this.$router.push({name:'entUserForm', params:{userId:this.$store.state.user.userInfo.id}})
        }else{
             ///console.log("userID===="+this.$store.state.user.userInfo.id)
           /////this.$router.push({path:'/system/personalInfor'})
           this.$router.push({name:'personalInfor', params:{userId:this.$store.state.user.userInfo.id}})
        }
      
    }
  }
}
</script>

<style lang="scss" scoped>
.navbar-logo{
    display: flex;
    width: 100%;
  
}

.top-logo{
    position: absolute;
    background: url('../../assets/images/gh1.png') center center no-repeat;
    background-size: 100% 100%;
    width: 432px;
    height: 63px;
    left: 34px;
    top: 16px;
    z-index: 99;
    
}

.top-logo span{
            display: block;
            margin-left: 441px;
            margin-top: 10px;
            // display: inline-block;
            //position: absolute;
            width: 610px;
            height: 37px;
            left: 578px;///482px;
            font-size: 28px;
            color: #ffffff;
            line-height: 37px; 
        }
/deep/ .el-tooltip__popper {
        background-color: black !important;
    }
.header-svg-call{
   margin-top: 14px;
color: #ffffff;
margin-right: 10px;
cursor: pointer;
  font-size: 20px;
  
}
.header-text{
  display: inline-block;
  margin: 0
}
.header-company-name{
  // position: absolute;
  // width: 144px;
height: 16px;
font-size: 12px;
text-align: right;
color: #FFFFFF;
margin: 0;
line-height: 16px;
letter-spacing: 1px;
margin-top: 23px;
margin-right: 16px;
}
.header-svg{
 font-size: 16px;
 margin-top: 14px;
color: #ffffff;
margin-right: 10px;
cursor: pointer;
}
.header-msg{
//  margin-top: 14px;
cursor: pointer;
    display: inline-block;
    width: 135px;
    height: 20px;
    font-size: 14px;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 20px;
    margin-right: 30px;
}
.login-titleSys {
  display: inline-block;
  position: absolute;
  width: 385px;
  height: 54px;
  left: 108px;
  color: #ffffff;
  line-height: 37px;
  top: 21px;

}
    .h1css{
        margin-top: 0px;
        font-size: 30px;
        color: #ffffff;
  }
  .h2css{
      margin-top: -11px;
      font-size: 19px;
  }
.login-title {
  display: inline-block;
  position: absolute;
  width: 610px;
  height: 37px;
  left: 578px;///482px;
  font-size: 28px;
  color: #ffffff;
  line-height: 37px;
  top: 23px;
}
.el-dropdown-menu {
  padding: 2px 0;
}

.el-dropdown-menu__item {
  margin: 2px 0;
  line-height: 27px;
}
.el-dropdown-menu__item--divided {
  position: relative;
  margin-top: 0px;
  border-top: 1px solid #ebeef5;
}
.el-dropdown-menu__item--divided:before {
  content: '';
  height: 2px;
  display: block;
  margin: 0 -20px;
  background-color: #fff;
}

.el-dropdown {
  color: #fff;
}
.user-name {
  margin-left: 10px;
  cursor: pointer;
}

.header-right {
  float: right;
  padding-right: 20px;
  position: relative;
}

.btn-bell,
.btn-fullscreen {
  position: relative;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}
.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}
.btn-bell .el-icon-bell {
  color: #fff;
}
.user-avator {
  margin-left: 20px;
}
.user-avator img {
  display: block;
  width: 26px;
  height: 26px;
  border-radius: 50%;
}
.iconfont {
  font-size: 23px;
  color: #ffffff;
}
.navbar {
  background: url('../../assets/images/top.png') center center;
  background-size: 100% 100%;
  height: 95px;
  min-width: 1200px;
  overflow: hidden;
  width: 100%;
  position: fixed;
  // position: relative;
 /// background: #074fa0;
  z-index: 100;
  //   box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

 
  .logoimg {
    position: absolute;
    background: url('../../assets/images/gh1.png') center center no-repeat;
    background-size: 100% 100%;
    width: 432px;
    height: 63px;
    left: 134px;///10%;///34px;
    top: 16px;
    z-index: 99;
  }
  .header-img-left {
    position: absolute;
   // background: url('../../assets/images/header-left.png') center center no-repeat;
    background-size: 100% 100%;
    top: 0;
    left: 0;
    width: 108px;
    height: 95px;
  }
  .header-img-center {
    position: absolute;
    ///background: url('../../assets/images/header-center.png') center center  no-repeat;
    background-size: 100% 100%;
    left: 650px;
    top: 0;
    width: 474px;
    height: 95px;
  }
  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    // margin-top: 1%;
    height: 100%;
    line-height: 60px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }
    .logot-btn {
      float: right;
      margin-right: 30px;
      line-height: 75px;
    }
    .msg-btn {
      float: left;
      margin-right: 30px;
      line-height: 75px;
    }
    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
